import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["login"]

    connect()
    {
        this.loginTarget.addEventListener("click", e =>
        {
            window.App.LOGGING_IN = true;
        })
    }
}